import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner,
  Form,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import {
  notaRemisionPorId,
  notasRemisionDePedido,
  notaDesdeSurtido,
  dibujaNotaRemision,
  totalesNota,
} from "../../Admin/Ventas/notaRemisionPDF";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import Baja from "../../Baja";
import BajaMultiple from "../../BajaMultiple";
import StatusMultipleSurtido from "../../StatusMultipleSurtido";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import AutorizadoMultiple from "../../AutorizadoMultiple";
import TextField from "@material-ui/core/TextField";
import Autocomplete, { createFilterOptions } from "@material-ui/lab/Autocomplete";

function ListadoPendienteSurtir() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;
  const URL_PEDIDOS = process.env.REACT_APP_URL_PEDIDOS;
  const URL_ARTICULOS_PEDIDO = process.env.REACT_APP_URL_ARTICULOS_PEDIDO;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_COLABORADORES_CLIENTES = process.env.REACT_APP_URL_COLABORADORES_CLIENTES;
  const URL_COLABORADORES_TALLAS = process.env.REACT_APP_URL_COLABORADORES_TALLAS;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_AREAS = process.env.REACT_APP_URL_AREAS;
  const URL_SURTIDOS = process.env.REACT_APP_URL_SURTIDOS;
  const URL_INVENTARIOS = process.env.REACT_APP_URL_INVENTARIOS;
  const URL_ARTICULOS_SURTIDOS = process.env.REACT_APP_URL_ARTICULOS_SURTIDOS;
  const ordenTallas = ["2XCH","XCH","EXTRA CHICA","CHICA","CH","M","MEDIANA","GRANDE","G","EXTRA GRANDE","XG","2XG","XXG","3XG","XXXG","4XG","XXXXG","5XG","XXXXXG","ESP","VARIOS","2","4","6","8","9","10","11","12","13","14","15","16","17","18","19","20","21","22","23","24","25","26","27","28","29","30","31","32","33","34","35","36","37","38","39","40","41","42","43","44","45","46","47","48","49","50","51","52","53","54","55","56"];
  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");

  const [clientesName, setClientesName] = useState([]);
  const [clientesCodigo, setClientesCodigo] = useState([]);

  const [colaboradores, setColaboradores] = useState([]);
  const [selectedColaborador, setSelectedColaborador] = useState("");
  const [selectedArea, setSelectedArea] = useState("");
  const [selectedFechaInicio, setSelectedFechaInicio] = useState("");
  const [selectedFechaFin, setSelectedFechaFin] = useState("");

  const [numero_pedido, setNumeroPedido] = useState("");
  const [empresa, setEmpresa] = useState("");
  const [descuento, setDescuento] = useState(0);
  const [descuento2, setDescuento2] = useState(0);
  const [selectedNombreColaborador, setSelectedNombreColaborador] = useState("");
  const [colaboradoresCliente, setColaboradoresCliente] = useState([]);
   const [value, setValue] = useState("");
   const [colaboradoresTallas, setColaboradoresTallas] = useState([]);
const [selectedColaboradorCliente, setSelectedColaboradorCliente] = useState(null);
const [abrirSurtirColaborador, setAbrirSurtirColaborador] = useState(false);
const [modalSurtirColaborador, setModalSurtirColaborador] = useState(false);
const toggleModalSurtirColaborador = () => setModalSurtirColaborador(!modalSurtirColaborador);
const [esModoColaborador, setEsModoColaborador] = useState(false);

// Surtir por Sucursal
const [modalSurtirSucursal, setModalSurtirSucursal] = useState(false);
const toggleModalSurtirSucursal = () => setModalSurtirSucursal(!modalSurtirSucursal);
const [sucursalesDisponibles, setSucursalesDisponibles] = useState([]);
const [selectedSucursal, setSelectedSucursal] = useState("");
const [selectedSucursalColaborador, setSelectedSucursalColaborador] = useState("");

const [modoSurtido, setModoSurtido] = useState(""); // "", "normal", "colaborador", "sucursal"
const [guardandoSurtido, setGuardandoSurtido] = useState(false);

  const [inventarios, setInventarios] = useState([]);
  const [fecha, setFecha] = useState(hoy);
  const [areas, setAreas] = useState([]);
  const [observaciones, setObservaciones] = useState("NA");
  const [entregadoCon, setEntregadoCon] = useState("");
  // (2026-10) obligatorio en cualquier tipo de entrega
  const [numeroFactura, setNumeroFactura] = useState("");
  const [total, setTotal] = useState(0);

  const [precio, setPrecio] = useState(0);
  const [idArticulo, setIdArticulo] = useState("");


  const [selectedSociedad, setSelectedSociedad] = useState("");
  const [selectedPedido, setSelectedPedido] = useState("");
  const [cliente, setCliente] = useState("");

  const [articulosPed, setArticulosPed] = useState([]);

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso((prev) => !prev);
  const [validaBoton, setValidaBoton] = useState(true);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);

  const [modalAlmacen, setModalAlmacen] = useState(false);
  const toggleAlmacen = () => setModalAlmacen(!modalAlmacen);

  const [fechaPDFOC, setFechaPDFOC] = useState("");
  const [colaboradoresPDFOC, setColaboradoresPDFOC] = useState("");
  const [clientesPDFOC, setClientesPDFOC] = useState("");
  const [observacionesPDFOC, setObservacionesPDFOC] = useState("");
  const [numeroPDFOC, setNumeroPDFOC] = useState("");
  const [idPDFOC, setIdPDFOC] = useState("");

  const [abrirSurtir, setAbrirSurtir] = useState(false);

  const [activo, setActivo] = useState("");
  const [impuestos, setImpuestos] = useState(0);
  const [comisionFlete, setComisionFlete] = useState(0);
  const [comisionTDC, setComisionTDC] = useState(0);

  const [idColaborador, setIdColaborador] = useState("");

  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      articulos: "",
      cantidad: 0,
      cantInv: 0,
      idInv: "",
      idArtPed: "",
      precio: 0,
      total: 0,
      // descuento: 0,
      pendSurtir: 0,
      cantPed: 0,
      idTalla:"",
      talla:"",
      idColor:"",
      color:"",
    },
  ]);

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  // (2026-10) Un solo mapeo del pedido para la carga inicial y para la
  // recarga después de guardar un surtido (antes la recarga tenía su propia
  // copia sin los campos nuevos y esas columnas se quedaban vacías).
  const mapeaPedido = (a) => ({
    _id: a._id,
    numero: a.idPedido,
    activo: a.is_active,
    fecha: a.fecha,
    colaboradores: a.colaboradores[0].nombre + " " + a.colaboradores[0].apellido,
    idColaboradores: a.colaboradores[0]._id,
    observaciones: a.observaciones,
    total_general: a.total_general,
    clientes: a.clientes[0].nombre_comercial,
    idClientes: a.clientes[0]._id,
    clientesCodigo: a.clientes[0].numero,
    idClientes: a.clientes[0]._id,
    total_piezas: a.total_piezas,
    status: a.status,
    autorizado: a.autorizado,
    surtido: a.surtido,
    impuestos: a.impuestos,
    empresa: a.empresas[0]._id,
    empresaNombre: a.empresas[0].name,
    subCliente: a.subCliente || "NA",
    // articulo: "Ref: " + a.articulos[0].codigo + " / Desc: " + a.articulos[0].descripcion,
    fecha_cancelacion: a.fecha_cancelacion,
    fecha_confirmacion: a.fecha_confirmacion,
    idSociedad: a.sociedades[0]._id,
    // compradores: a.compradores[0].name,
    // idCompradores: a.compradores[0]._id,
    pedidoCliente: a.pedidoCliente,
    observaciones: a.observaciones,
    cantidad: parseFloat(a.total_piezas),
    precioPrenda: parseFloat(a.total_general) / parseFloat(a.total_piezas),
    // (2026-10) piezas pedidas / surtidas / pendientes que calcula el back
    cantidadPedida: Number(a.cantidadPedida || 0),
    cantidadSurtida: Number(a.cantidadSurtida || 0),
    pendienteSurtir: Number(a.pendienteSurtir || 0),
  });

  useMemo(() => {
    setSelectedArea(user.areas);
    axios
      .get(`${URL_PEDIDOS}PendienteSurtir`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allPedidos = response.data;
        // Array para pagination
        let arrayTabla = allPedidos
          .sort((a, b) => (a.idPedido > b.idPedido ? 1 : -1))
          .map(mapeaPedido)
          .filter(function (el) {
            return el != null;
          });

        let data = Object.values(arrayTabla);

        setComments(data);

        //
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allClientes = response.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_COLABORADORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allColaboradores = response.data;
        setColaboradores(allColaboradores);
      })
      .catch((err) => {
        console.log(err);
      });


    axios
      .get(URL_AREAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allAreas = res.data;
        setAreas(allAreas);
      })
      .catch((err) => {
        console.log(err);
      });

  }, [user]);


  function PDFTabla() {
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (activo == 0 || activo == a.is_active) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes)
      ) {
        return [
          a.activo,
          a.numero,
          a.fecha,
          a.colaboradores,
          a.clientes,
          a.cantidadPedida,
          a.cantidadSurtida,
          a.pendienteSurtir,
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.total_general),
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 15, 45, 15);
    doc.text(`Listado Pedidos`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Activo",
          "Numero",
          "Fecha",
          "Vendedor",
          "Cliente",
          "Cant. Pedida",
          "Cant. Surtida",
          "Pendiente por Surtir",
          "Total",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
    });
    // doc.save(`Pedidos.pdf`);
    window.open(doc.output("bloburl"), "_blank");
  }

  function excel() {
    const dataExcel = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (activo == 0 || activo == a.is_active) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes)
      ) {
        return {
          Activo: a.activo,
          Numero: a.numero,
          Fecha: a.fecha,
          Vendedor: a.colaboradores,
          Cliente: a.clientes,
          CantidadPedida: a.cantidadPedida,
          CantidadSurtida: a.cantidadSurtida,
          PendienteSurtir: a.pendienteSurtir,
          Total: a.total_general,
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoPedidos";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoPedidos",
        sheetFilter: [
          "Activo",
          "Numero",
          "Fecha",
          "Vendedor",
          "Cliente",
          "CantidadPedida",
          "CantidadSurtida",
          "PendienteSurtir",
          "Total",
        ],
        sheetHeader: [
          "Activo",
          "Numero",
          "Fecha",
          "Vendedor",
          "Cliente",
          "Cant. Pedida",
          "Cant. Surtida",
          "Pendiente por Surtir",
          "Total",
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (activo == 0 || activo == a.is_active) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes)
      ) {
        return [
          a.activo,
          a.numero,
          a.fecha,
          a.colaboradores,
          a.clientes,
          a.cantidadPedida,
          a.cantidadSurtida,
          a.pendienteSurtir,
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.total_general),
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 15, 45, 15);
    doc.text(`Listado Ordenes de Compra`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Activo",
          "Numero",
          "Fecha",
          "Vendedor",
          "Cliente",
          "Cant. Pedida",
          "Cant. Surtida",
          "Pendiente por Surtir",
          "Total",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
    });
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado Pedidos",
          email: mailTo,
          fileName: "ListadoPedidos.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Pedidos.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

// (2026-10) PDF del pedido pendiente por surtir con el formato nuevo de
// documento (el de la nota de remisión): encabezado con empresa y folio,
// cuadro de datos, resumen de piezas, un bloque por modelo con lo pedido /
// surtido / pendiente por color y talla, bordados, totales y pie con páginas.
// Al final se anexan las notas de remisión que han salido del pedido, con el
// mismo formato que la nota de ListadoVentas.
async function PDFOC(
  fecha,
  colaboradores,
  clientes,
  pedidoCliente,
  numero,
  idPDFOC,
  extra = {}
) {
  const getImageAsDataURL = (url) =>
    new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => {
        try {
          const canvas = document.createElement("canvas");
          canvas.width = img.naturalWidth;
          canvas.height = img.naturalHeight;
          canvas.getContext("2d").drawImage(img, 0, 0);
          resolve({
            data: canvas.toDataURL("image/png"),
            w: img.naturalWidth,
            h: img.naturalHeight,
          });
        } catch (e) {
          reject(e);
        }
      };
      img.onerror = reject;
      img.src = url;
    });
  // el public_id ya puede traer la URL completa; si no, se arma con la cuenta
  const urlBordado = (publicId) => {
    const p = String(publicId || "").trim();
    if (!p) return "";
    if (p.startsWith("http")) return p;
    const base = String(process.env.REACT_APP_URL_FOTO_CLOUDINARY || "")
      .replace(/\/$/, "")
      .replace(/\/image\/upload$/, "");
    return `${base}/image/upload/${p}`;
  };

  try {
    const { data: allArticulosPedido } = await axios.get(
      `${URL_ARTICULOS_PEDIDO}/pedidos/${idPDFOC}`,
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    );

    // notas de remisión del pedido; si no se pueden traer, el PDF sale sin ellas
    let notas = [];
    try {
      notas = await notasRemisionDePedido(idPDFOC);
    } catch (err) {
      console.warn("No se pudieron traer las notas de remisión:", err);
    }
    const notasConPrecio = notas.length
      ? (
          await Swal.fire({
            title: "¿Las notas de remisión salen con precio?",
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Sí",
            cancelButtonText: "No",
          })
        ).isConfirmed
      : false;

    const txt = (v) => String(v ?? "").trim();
    const dato = (v) => {
      const t = txt(v);
      return !t || ["NA", "NO"].includes(t.toUpperCase()) ? "" : t;
    };
    const num = (n) => new Intl.NumberFormat("en-US").format(Number(n || 0));
    const moneda = (n) =>
      "$" +
      new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(Number(n || 0));
    const fechaCorta = (f) => {
      const [a, m, d] = txt(f).slice(0, 10).split("-");
      return a && m && d ? `${d}/${m}/${a}` : txt(f);
    };

    const ordenTallas = ["2XCH","XCH","EXTRA CHICA","CHICA","CH","M","MEDIANA","GRANDE","G","EXTRA GRANDE","XG","2XG","XXG","3XG","XXXG","4XG","XXXXG","5XG","XXXXXG","ESP","VARIOS","2","4","6","8","9","10","11","12","13","14","15","16","17","18","19","20","21","22","23","24","25","26","27","28","29","30","31","32","33","34","35","36","37","38","39","40","41","42","43","44","45","46","47","48","49","50","51","52","53","54","55","56"];
    const posTalla = (t) => {
      const i = ordenTallas.indexOf(t);
      return i === -1 ? Infinity : i;
    };

    // ---- Surtido repartido por variante (artículo + color + talla). Al
    // surtir, todo lo de una variante se le carga al primer renglón que la
    // tiene; aquí se reparte en orden entre sus renglones (hasta su cantidad,
    // lo que sobre al último) para que no salga uno sobresurtido y otro
    // "pendiente" cuando la variante está completa.
    const idDe = (v) => String(v?._id || v || "");
    const claveVariante = (a) =>
      [a.articulos?.[0], a.colores?.[0], a.tallas?.[0]].map(idDe).join("|");
    const porVariante = {};
    allArticulosPedido.forEach((a) => {
      const k = claveVariante(a);
      if (!porVariante[k]) porVariante[k] = { surtido: 0, renglones: [] };
      porVariante[k].surtido += Number(a.surtido || 0);
      porVariante[k].renglones.push(a);
    });
    const surtidoAsignado = new Map();
    Object.values(porVariante).forEach(({ surtido, renglones }) => {
      let resta = surtido;
      renglones.forEach((a, i) => {
        const cantidad = Number(a.cantidad || 0);
        const toca =
          i === renglones.length - 1
            ? Math.max(0, resta)
            : Math.max(0, Math.min(cantidad, resta));
        surtidoAsignado.set(a, toca);
        resta -= toca;
      });
    });

    // ---- Agrupado: sucursal + área + modelo → color → talla
    const grupos = {};
    allArticulosPedido.forEach((a) => {
      const sucursal = a.sucursales?.[0]?.alias || "";
      const area = a.areasClientes?.[0]?.name || "Sin área";
      const art = a.articulos?.[0] || {};
      const modelo =
        [txt(art.codigo), txt(art.subDepartamentos?.[0]?.name)]
          .filter((t) => t)
          .join(" ") || "Artículo sin nombre";
      const clave = `${sucursal}||${area}||${modelo}`;
      if (!grupos[clave]) {
        grupos[clave] = {
          sucursal,
          area,
          modelo,
          precio: Number(a.precio || 0),
          bordados: a.bordados || [],
          colores: {},
          tallas: new Set(),
        };
      }
      const g = grupos[clave];
      const color = a.colores?.[0]?.name || "Sin color";
      const talla = txt(a.tallas?.[0]?.name) || "Sin talla";
      const variante = txt(a.tallas?.[0]?.variantesTallas?.[0]?.name);
      if (!g.colores[color]) g.colores[color] = {};
      if (!g.colores[color][talla]) g.colores[color][talla] = [];
      g.colores[color][talla].push({
        cantidad: Number(a.cantidad || 0),
        surtido: surtidoAsignado.get(a) || 0,
        detalle: variante ? `(${variante})` : "",
      });
      g.tallas.add(talla);
    });

    // ---- Totales (el pendiente se suma renglón por renglón y nunca es
    // negativo, para que cuadre con las celdas aunque haya sobresurtido)
    let totPedida = 0;
    let totSurtida = 0;
    let totPendiente = 0;
    let totImporte = 0;
    Object.values(grupos).forEach((g) => {
      let pedidaGrupo = 0;
      Object.values(g.colores).forEach((porTalla) =>
        Object.values(porTalla).forEach((regs) =>
          regs.forEach(({ cantidad, surtido }) => {
            pedidaGrupo += cantidad;
            totSurtida += surtido;
            totPendiente += Math.max(0, cantidad - surtido);
          })
        )
      );
      totPedida += pedidaGrupo;
      totImporte += pedidaGrupo * g.precio;
    });
    const iva = totImporte * 0.16;

    // ---- Estilo
    const doc = new jsPDF();
    const pageW = doc.internal.pageSize.getWidth();
    const pageH = doc.internal.pageSize.getHeight();
    const ML = 15;
    const anchoUtil = pageW - ML * 2;
    const azul = [30, 58, 138];
    const azulClaro = [37, 99, 235];
    const fondoEtiqueta = [238, 244, 255];
    const borde = [169, 180, 200];
    const rojo = [192, 0, 0];
    const tinta = [30, 30, 30];

    const empresa =
      txt(extra.empresa) || txt(process.env.REACT_APP_NOMBRE_INSTITUCION);
    const cliente =
      txt(clientes) +
      (dato(extra.subCliente) ? ` (${txt(extra.subCliente)})` : "");

    // ---- Encabezado
    doc.setFont(undefined, "bold").setFontSize(17).setTextColor(...azul);
    doc.text(empresa.toUpperCase(), ML, 20);
    doc.setFontSize(11.5).setTextColor(...azulClaro);
    doc.text("PENDIENTE POR SURTIR", ML, 26.5);
    doc.setFontSize(10.5).setTextColor(...azul);
    doc.text("PEDIDO", pageW - ML, 19, { align: "right" });
    doc.setFontSize(16).setTextColor(...rojo);
    doc.text(String(numero), pageW - ML, 26.5, { align: "right" });
    doc.setTextColor(0).setFont(undefined, "normal");

    // ---- Cuadro de datos
    const etiqueta = (content) => ({
      content,
      styles: { fillColor: fondoEtiqueta, textColor: azul, fontStyle: "bold" },
    });
    const estiloCuadro = {
      fontSize: 9.5,
      cellPadding: 2,
      valign: "middle",
      lineColor: borde,
      lineWidth: 0.25,
      textColor: tinta,
    };
    doc.autoTable({
      startY: 30,
      margin: { left: ML, right: ML },
      tableWidth: anchoUtil,
      theme: "grid",
      styles: estiloCuadro,
      columnStyles: { 0: { cellWidth: 30 }, 1: { cellWidth: 60 }, 2: { cellWidth: 34 } },
      body: [
        [etiqueta("Empresa:"), empresa, etiqueta("Fecha pedido:"), fechaCorta(fecha)],
        [etiqueta("Cliente:"), cliente, etiqueta("Fecha entrega:"), fechaCorta(extra.fechaEntrega)],
        [etiqueta("Vendedor:"), txt(colaboradores), etiqueta("Pedido cliente:"), dato(pedidoCliente)],
      ],
    });

    // ---- Resumen de piezas
    doc.autoTable({
      startY: doc.autoTable.previous.finalY + 3,
      margin: { left: ML, right: ML },
      tableWidth: anchoUtil,
      theme: "grid",
      styles: { ...estiloCuadro, halign: "center", fontSize: 10 },
      body: [
        [
          etiqueta("CANTIDAD PEDIDA"),
          { content: num(totPedida), styles: { fontStyle: "bold" } },
          etiqueta("CANTIDAD SURTIDA"),
          { content: num(totSurtida), styles: { fontStyle: "bold" } },
          etiqueta("PENDIENTE POR SURTIR"),
          { content: num(totPendiente), styles: { fontStyle: "bold", textColor: rojo } },
        ],
      ],
    });

    let y = doc.autoTable.previous.finalY + 7;
    const margenAbajo = 20;
    const asegura = (alto) => {
      if (y + alto > pageH - margenAbajo) {
        doc.addPage();
        y = 18;
      }
    };

    // ---- Un bloque por modelo
    for (const g of Object.values(grupos)) {
      // Se calcula lo que ocupa el modelo completo (banda + tabla + bordados)
      // para pasarlo entero a la hoja siguiente si no cabe, en vez de partirlo.
      const lineasColor = Object.values(g.colores).map((porTalla) =>
        Math.max(1, ...Object.values(porTalla).map((regs) => regs.length))
      );
      const altoTabla =
        7 + lineasColor.reduce((t, l) => t + 3 * (2.6 + 3.4 * l), 0);
      const nBordados = (g.bordados || []).filter((b) => urlBordado(b.public_id))
        .length;
      const porFila = Math.max(1, Math.floor(anchoUtil / 35));
      const altoBordados = nBordados ? 6 + Math.ceil(nBordados / porFila) * 30 : 0;
      const altoBloque = 8 + altoTabla + 4 + altoBordados;
      const altoHoja = pageH - margenAbajo - 18;
      if (y + altoBloque > pageH - margenAbajo && altoBloque <= altoHoja) {
        doc.addPage();
        y = 18;
      }
      asegura(30);
      // banda del modelo
      doc.setFillColor(...fondoEtiqueta).setDrawColor(...borde).setLineWidth(0.25);
      doc.rect(ML, y, anchoUtil, 8, "FD");
      doc.setFont(undefined, "bold").setFontSize(10).setTextColor(...azul);
      const txtPrecio = `Precio: ${moneda(g.precio)}`;
      doc.text(txtPrecio, pageW - ML - 3, y + 5.4, { align: "right" });
      // el título va en un solo renglón: si no cabe se achica la letra y, ya
      // al mínimo, se corta con "…" (antes se bajaba y se encimaba con la tabla)
      const anchoTitulo = anchoUtil - doc.getTextWidth(txtPrecio) - 10;
      let titulo = `${g.modelo}  ·  Área: ${g.area}${
        g.sucursal ? `  ·  Sucursal: ${g.sucursal}` : ""
      }`;
      let tam = 10;
      while (tam > 7.5 && doc.getTextWidth(titulo) > anchoTitulo) {
        tam -= 0.5;
        doc.setFontSize(tam);
      }
      while (titulo.length > 1 && doc.getTextWidth(titulo) > anchoTitulo) {
        titulo = titulo.slice(0, -2) + "…";
      }
      doc.text(titulo, ML + 3, y + 5.4);
      y += 8;

      const tallas = [...g.tallas].sort((a, b) => posTalla(a) - posTalla(b));
      const body = [];
      Object.keys(g.colores).forEach((color) => {
        const celdas = { pedida: [], surtida: [], pendiente: [] };
        let tPed = 0;
        let tSur = 0;
        let tPen = 0;
        tallas.forEach((t) => {
          const regs = g.colores[color][t] || [];
          let p1 = "";
          let p2 = "";
          let p3 = "";
          regs.forEach(({ cantidad, surtido, detalle }) => {
            const falta = Math.max(0, cantidad - surtido);
            p1 += `${cantidad} ${detalle}\n`;
            p2 += `${surtido} ${detalle}\n`;
            p3 += `${falta} ${detalle}\n`;
            tPed += cantidad;
            tSur += surtido;
            tPen += falta;
          });
          celdas.pedida.push(p1.trim());
          celdas.surtida.push(p2.trim());
          celdas.pendiente.push(p3.trim());
        });
        body.push([
          { content: color, rowSpan: 3, styles: { fontStyle: "bold", valign: "middle" } },
          { content: "PEDIDA", styles: { fontStyle: "bold", halign: "left" } },
          ...celdas.pedida,
          { content: num(tPed), styles: { fontStyle: "bold" } },
        ]);
        body.push([
          { content: "SURTIDA", styles: { fontStyle: "bold", halign: "left" } },
          ...celdas.surtida,
          { content: num(tSur), styles: { fontStyle: "bold" } },
        ]);
        body.push([
          { content: "PENDIENTE", styles: { fontStyle: "bold", halign: "left", textColor: rojo } },
          ...celdas.pendiente.map((c) => ({ content: c, styles: { textColor: rojo } })),
          { content: num(tPen), styles: { fontStyle: "bold", textColor: rojo } },
        ]);
      });

      // si aun así la tabla no cabe en una hoja, la continuación dice de qué
      // modelo es
      const paginaInicio = doc.internal.getCurrentPageInfo().pageNumber;
      doc.autoTable({
        startY: y,
        margin: { left: ML, right: ML, bottom: margenAbajo, top: 24 },
        didDrawPage: () => {
          if (doc.internal.getCurrentPageInfo().pageNumber <= paginaInicio) return;
          doc.setFont(undefined, "bold").setFontSize(10).setTextColor(...azul);
          doc.text(`${g.modelo}  ·  Área: ${g.area}  (continúa)`, ML, 19);
        },
        tableWidth: anchoUtil,
        theme: "grid",
        head: [["COLOR", "", ...tallas, "TOTAL"]],
        body,
        styles: {
          fontSize: 8.5,
          cellPadding: 1.2,
          valign: "middle",
          halign: "center",
          overflow: "linebreak",
          lineColor: borde,
          lineWidth: 0.2,
          textColor: tinta,
        },
        headStyles: { fillColor: azul, textColor: [255, 255, 255], fontStyle: "bold" },
        columnStyles: { 0: { cellWidth: 28 }, 1: { cellWidth: 21 } },
      });
      y = doc.autoTable.previous.finalY + 4;

      // bordados del modelo
      const bordados = (g.bordados || []).filter((b) => urlBordado(b.public_id));
      if (bordados.length) {
        asegura(26);
        doc.setFont(undefined, "bold").setFontSize(9).setTextColor(...azul);
        doc.text("Bordados", ML, y + 3);
        y += 5;
        let x = ML;
        let altoFila = 0;
        for (const b of bordados) {
          try {
            const im = await getImageAsDataURL(urlBordado(b.public_id));
            const ratio = Math.min(24 / im.w, 14 / im.h);
            const w = im.w * ratio;
            const h = im.h * ratio;
            if (x + Math.max(w, 30) > pageW - ML) {
              x = ML;
              y += altoFila + 3;
              altoFila = 0;
            }
            asegura(h + 10);
            doc.addImage(im.data, "PNG", x, y, w, h);
            const obs = doc
              .setFont(undefined, "normal")
              .setFontSize(7.5)
              .setTextColor(...tinta)
              .splitTextToSize(txt(b.observacion), Math.max(w, 30));
            doc.text(obs.slice(0, 3), x, y + h + 3.5);
            altoFila = Math.max(altoFila, h + 3.5 + Math.min(obs.length, 3) * 3.2);
            x += Math.max(w, 30) + 5;
          } catch (err) {
            console.warn("No se pudo mostrar bordado:", b.public_id);
          }
        }
        y += altoFila + 4;
      }
      y += 3;
    }

    // ---- Totales del pedido (importe de lo pedido)
    const anchoTot = 70;
    asegura(30);
    doc.autoTable({
      startY: y,
      margin: { left: pageW - ML - anchoTot, right: ML },
      tableWidth: anchoTot,
      theme: "grid",
      styles: { ...estiloCuadro, fontSize: 10, cellPadding: 2.3 },
      columnStyles: { 0: { cellWidth: 30 }, 1: { halign: "right" } },
      body: [
        [etiqueta("SUB TOTAL"), moneda(totImporte)],
        [etiqueta("IVA"), moneda(iva)],
        [
          etiqueta("TOTAL"),
          { content: moneda(totImporte + iva), styles: { fontStyle: "bold", textColor: azul } },
        ],
      ],
    });

    // ---- Notas de remisión que han salido del pedido (resumen)
    if (notas.length) {
      // mismos números que la caja de totales de cada nota
      const totNota = (n) =>
        totalesNota(n.articulos, n.surtido.descuento, n.surtido.descuento2);
      y = doc.autoTable.previous.finalY + 8;
      asegura(24);
      doc.setFont(undefined, "bold").setFontSize(10.5).setTextColor(...azul);
      doc.text("NOTAS DE REMISIÓN DEL PEDIDO", ML, y);
      const headNotas = ["FOLIO", "FECHA", "# FACTURA", "PIEZAS"];
      if (notasConPrecio) headNotas.push("IMPORTE");
      const totPiezasNotas = notas.reduce((t, n) => t + totNota(n).piezas, 0);
      const totImporteNotas = notas.reduce((t, n) => t + totNota(n).total, 0);
      const pieNotas = ["", "", "TOTAL", num(totPiezasNotas)];
      if (notasConPrecio) pieNotas.push(moneda(totImporteNotas));
      doc.autoTable({
        startY: y + 2,
        margin: { left: ML, right: ML, bottom: margenAbajo },
        tableWidth: anchoUtil,
        theme: "grid",
        head: [headNotas],
        body: notas.map((n) => {
          const fila = [
            String(n.surtido.idSurtido ?? ""),
            fechaCorta(n.surtido.fecha),
            dato(n.surtido.numeroFactura),
            num(totNota(n).piezas),
          ];
          if (notasConPrecio) fila.push(moneda(totNota(n).total));
          return fila;
        }),
        foot: [pieNotas],
        showFoot: "lastPage",
        styles: { ...estiloCuadro, halign: "center" },
        headStyles: { fillColor: azul, textColor: [255, 255, 255], fontStyle: "bold" },
        footStyles: { fillColor: fondoEtiqueta, textColor: azul, fontStyle: "bold" },
      });
      doc.setFont(undefined, "normal").setFontSize(8.5).setTextColor(...tinta);
      doc.text(
        "Cada nota se anexa completa en las hojas siguientes.",
        ML,
        doc.autoTable.previous.finalY + 5
      );
    }

    // ---- Pie de página en las hojas del pendiente (las notas llevan el suyo)
    const nPaginas = doc.internal.getNumberOfPages();
    for (let i = 1; i <= nPaginas; i++) {
      doc.setPage(i);
      doc.setFont(undefined, "normal").setFontSize(8.5).setTextColor(60, 60, 60);
      doc.text(`${empresa.toUpperCase()} - Pendiente por Surtir`, ML, pageH - 10);
      doc.text(`Pedido: ${numero}`, pageW / 2, pageH - 10, { align: "center" });
      doc.text(`Página ${i} de ${nPaginas}`, pageW - ML, pageH - 10, { align: "right" });
    }
    doc.setTextColor(0);

    // ---- Notas anexas, cada una en hoja nueva
    notas.forEach((n) => {
      doc.addPage();
      dibujaNotaRemision(doc, {
        ...notaDesdeSurtido(n.surtido, n.articulos),
        mostrarPrecio: notasConPrecio,
      });
    });

    window.open(doc.output("bloburl"), "_blank");
  } catch (err) {
    console.error("Error generando PDFOC:", err);
    Swal.fire("Error", "No se pudo generar el PDF", "error");
  }
}



  const headers = [
    { name: "Numero", field: "numero", sortable: true },
    { name: "Fecha Alta Pedido", field: "fecha", sortable: true },
    { name: "Empresa", field: "empresa", sortable: true },
    { name: "Cliente", field: "clientes", sortable: true },
    { name: "Vendedor", field: "colaboradores", sortable: true },
    // { name: "Marca", field: "marca", sortable: true },
    // { name: "Articulo", field: "articulo", sortable: true },
    { name: "Pedido Cliente", field: "pedidoCliente", sortable: true },
    { name: "Fecha Cancelacion", field: "fecha_cancelacion", sortable: true },
    { name: "Cant. Pedida", field: "cantidadPedida", sortable: true },
    { name: "Cant. Surtida", field: "cantidadSurtida", sortable: true },
    { name: "Pendiente por Surtir", field: "pendienteSurtir", sortable: true },
    { name: "PDF", field: "pdf", sortable: false },
    { name: "Entregar", field: "surtir", sortable: false },
    { name: "Entregado", field: "surtido", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.empresa.toLowerCase().includes(search.toLowerCase()) ||
          comment.clientes.toLowerCase().includes(search.toLowerCase()) ||
          comment.colaboradores.toLowerCase().includes(search.toLowerCase()) ||
          // comment.marca.toLowerCase().includes(search.toLowerCase()) ||
          // comment.articulo.toLowerCase().includes(search.toLowerCase()) ||
          comment.pedidoCliente.toLowerCase().includes(search.toLowerCase()) ||
          comment.numero.toString().includes(search)
      );
    }
    if (selectedCliente) {
      computedComments = computedComments.filter((e) =>
        e.idClientes.includes(selectedCliente)
      );
    }
    if (selectedColaborador) {
      computedComments = computedComments.filter((e) =>
        e.idColaboradores.includes(selectedColaborador)
      );
    }
    if (activo) {
      computedComments = computedComments.filter((e) =>
        e.activo.includes(activo)
      );
    }

    if (selectedFechaInicio) {
      computedComments = computedComments.filter(
        (e) => e.fecha >= selectedFechaInicio
      );
    }

    if (selectedFechaFin) {
      computedComments = computedComments.filter(
        (e) => e.fecha <= selectedFechaFin
      );
    }

    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "numero"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedCliente,
    selectedColaborador,
    activo,
    selectedFechaInicio,
    selectedFechaFin,
  ]);

    const options = colaboradoresCliente.map((option) => {
    const junta = option.nombre;
    const firstLetter = option.nombre[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  });

  // save
const saveSurtidos = async (event) => {
  event.preventDefault();

  // (2026-10) toda entrega lleva su número de factura
  const facturaCapturada = String(numeroFactura || "").trim();
  if (!facturaCapturada || ["NA", "NO"].includes(facturaCapturada.toUpperCase())) {
    Swal.fire(
      "Falta el número de factura",
      "Captura el número de factura de esta entrega para poder guardarla.",
      "warning"
    );
    return;
  }

  try {
    setGuardandoSurtido(true);
    setValidaBoton(false);
    setModalProgreso(true);

    const articulosConCantidad = inputFields.filter(
      (a) => Number(a.cantidad) > 0
    );

    if (!articulosConCantidad.length) {
      Swal.fire("Error", "No capturaste cantidades para surtir", "error");
      setGuardandoSurtido(false);
      setValidaBoton(true);
      setModalProgreso(false);
      return;
    }

    let ST = articulosConCantidad.reduce(
      (acc, item) => acc + (Number(item.cantidad) * Number(item.precio)),
      0
    );

    let montoDescuento1 = ST * (Number(descuento || 0) / 100);
    let montoDescuento2 = ST * (Number(descuento2 || 0) / 100);

    let subtotalConDescuentos = Math.max(
      ST - montoDescuento1 - montoDescuento2,
      0
    );

    let iva = Number(impuestos || 0)
      ? (Number(impuestos) * subtotalConDescuentos) / 100
      : 0;

    let TT = subtotalConDescuentos + iva + Number(comisionFlete || 0) + Number(comisionTDC || 0);

    const surtidoResp = await axios.post(
      URL_SURTIDOS,
      {
        fecha,
        pedidos: selectedPedido,
        observaciones,
        numeroFactura: facturaCapturada,
        user: user.id,
        clientes: cliente,
        areas: selectedArea,
        total_general: TT,
        saldo: TT,
        subTotal: ST,
        iva,
        impuestos,
        is_active: "Si",
        empresas: empresa,
        descuento,
        descuento2,
        totalCantidad: articulosConCantidad.reduce(
          (acc, item) => acc + Number(item.cantidad || 0),
          0
        ),
        facturado: "No",
        colaboradores: idColaborador,
        sociedades: selectedSociedad,
        nombreColaborador: value?.nombre || "NA",
        sucursalColaborador: value?.sucursales?.[0]?.alias || "NA",
        areaColaborador: value?.areasClientes?.[0]?.name || "NA",
        numeroColaborador: value?.numero || "NA",
        entregadoCon,
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    );

    await Promise.all(
      articulosConCantidad.map((a) =>
        axios.post(
          URL_ARTICULOS_SURTIDOS,
          {
            surtidos: surtidoResp.data._id,
            inventarios: a.idInv,
            cantidad: parseFloat(a.cantidad),
            articulos: a.articulos,
            pedidos: selectedPedido,
            articulosPedido: a.idArtPed,
            areas: selectedArea,
            tallas: a.idTalla,
            colores: a.idColor,
            facturado: "No",
            colorFactura: a.color,
            sociedades: selectedSociedad,
            precio: a.precio,
            total: Number(a.cantidad) * Number(a.precio),
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
      )
    );

    await axios.post(
      URL_LOGS,
      {
        tipo: "Crear Surtido",
        detalle: `${numero_pedido} ${selectedArea}`,
        user: user.id,
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    );

    // recargar pendientes de la lista principal sin recargar página
    const pedidosResp = await axios.get(`${URL_PEDIDOS}PendienteSurtir`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    });

    const pedidosActualizados = (pedidosResp.data || [])
      .sort((a, b) => (a.idPedido > b.idPedido ? 1 : -1))
      .map(mapeaPedido);

    setComments(pedidosActualizados);

    // Mantenerte en la misma vista
    setAbrirSurtir(true);
    setAbrirSurtirColaborador(false);

    // limpiar captura
    setTotal(0);
    setNumeroFactura("");
    setInputFields((prev) =>
      prev.map((item) => ({
        ...item,
        cantidad: 0,
        total: 0,
      }))
    );

    // volver a cargar el colaborador actual para traer lo pendiente actualizado
    if (value?._id) {
      await cargarArticulosFiltradosPorColaborador(value);
    }

    // (2026-10) la nota de remisión (la misma de ListadoVentas) sale sola al
    // guardar; si falla, el surtido ya quedó guardado y se avisa nada más
    setModalProgreso(false);
    try {
      await notaRemisionPorId(surtidoResp.data._id);
    } catch (errNota) {
      console.log(errNota);
      await Swal.fire(
        "Surtido guardado",
        "No se pudo generar la nota de remisión; puedes sacarla desde Ventas.",
        "warning"
      );
    }

    Swal.fire({
      icon: "success",
      title: "Creado con éxito",
      text: "Puedes seguir surtiendo sin salir de la vista",
      timer: 1800,
      showConfirmButton: false,
    });
  } catch (error) {
    console.log(error);
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something went wrong!",
      footer: `${error?.response?.data || ""}`,
    });
  } finally {
    setGuardandoSurtido(false);
    setValidaBoton(true);
    setModalProgreso(false);
  }
};

  const handleAddFields = () => {
    const ultimo = inputFields[inputFields.length - 1];
    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        articulos: "",
        cantidad: 0,
        cantInv: 0,
        idInv: "",
        idArtPed: "",
        precio: 0,
        total: 0,
        // descuento: 0,
        pendSurtir: 0,
        cantPed: 0,
        idTalla:"",
        talla:"",
        idColor:"",
        color:"",
      },
    ]);
  };

  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);
    let cant = values.map((c) => parseFloat(c.cantidad));
    let TC = cant.reduce((t, total, index) => t + total, 0);
    setTotal(TC);
  };

  const handleChangeInputCantidad = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        if (
          (i.cantInv >= event.target.value 
            // &&
            // i.pendSurtir >= event.target.value
            ) ||
          event.target.value == ""
        ) {
          i[event.target.name] = event.target.value;
        
          i.total = parseFloat(event.target.value) * parseFloat(i.precio).toFixed(2);
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "La cantidad excede tu pedido!",
            showConfirmButton: false,
          });
          i.cantidad = 0;
        }
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };



  function ActualizaTotales() {
    let cant = inputFields.map((c) => parseFloat(c.cantidad));
    let TC = cant.reduce((t, total, index) => t + total, 0);
    setTotal(TC);

  }

async function seleccionarPedido(
  id,
  numero,
  idClientes,
  clientes,
  clientesCodigo,
  observaciones,
  empresa,
  idColaborador,
  idSociedad
) {
  try {
    setModoSurtido("normal");
setSelectedSucursalColaborador("");
    setSelectedPedido(id);
    setNumeroPedido(numero);
    setCliente(idClientes);
    setClientesName(clientes);
    setClientesCodigo(clientesCodigo);
    setObservaciones(observaciones);
    setNumeroFactura("");
    setEmpresa(empresa);
    setIdColaborador(idColaborador);
    setSelectedSociedad(idSociedad);

    const resp = await axios.get(
      `${URL_COLABORADORES_CLIENTES}/cliente/${idClientes}`,
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    );

    setColaboradoresCliente(resp.data);

    toggleAlmacen();
  } catch (error) {
    console.error("Error al cargar colaboradores:", error);
  }
}

  function surtirPedido(){

    axios
      .get(`${URL_INVENTARIOS}/traspasos/${selectedArea}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allInventarios = res.data;
        setInventarios(allInventarios);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(`${URL_ARTICULOS_PEDIDO}/surtir3/${selectedPedido}/${selectedArea}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allArticulosPed = res.data;
        setArticulosPed(allArticulosPed);

        let arrayInputFields = allArticulosPed.map((a) => {
          return {
            id: uuidv4(),
            articulos: a.articulos,
            cantidad: 0,
            cantInv: a.cantInv,
            idInv: a.idInv,
            idArtPed: a.idArtPed,
            precio: a.precio,
            total: (a.cantidad * a.precio - (a.cantidad * a.precio) / 100).toFixed(2),
            pendSurtir: a.pendiente_surtir,
            cantPed: a.cantPed,
            idTalla:a.idTalla,
            talla:a.talla,
            idColor:a.idColor,
            color:a.color,
            // descuento: a.descuento,
          };
        });

        let dataIF = Object.values(arrayInputFields);

        setInputFields(dataIF);
        setPrecio(dataIF[0].precio);
        // setIdArticulo(dataIF[0].articulos);
      })
      .catch((err) => {
        console.log(err);
      });
    toggleAlmacen(false)
    setEsModoColaborador(false);
    setAbrirSurtir(true)
  }

  const handleCopyAllCantidad = () => {
    const updatedFields = inputFields.map((field) => ({
      ...field,
      cantidad: field.cantInv, // Copia el valor de cantInv a cantidad
      total: (field.cantInv * field.precio).toFixed(2), // Calcula el total para cada campo
    }));
  
    setInputFields(updatedFields); // Actualiza los campos
  
    // Usa updatedFields para calcular el total
    const totalCantidad = updatedFields.reduce(
      (sum, field) => sum + (parseFloat(field.cantidad) || 0),
      0
    );
    setTotal(totalCantidad); // Actualiza el total general
  };
  
  // Función para ordenar por talla
const ordenarPorTalla = (a, b) => {
  const indexA = ordenTallas.indexOf(a.talla);
  const indexB = ordenTallas.indexOf(b.talla);
  return (indexA !== -1 ? indexA : ordenTallas.length) - (indexB !== -1 ? indexB : ordenTallas.length);
};

// Ordenamos inputFields primero por color y luego por talla
const collator = new Intl.Collator("es", {
  sensitivity: "base",
  numeric: true,
});

const inputFieldsOrdenados = [...inputFields].sort((a, b) => {

  // 1. Departamento
  let res = collator.compare(
    a.departamentoName || "",
    b.departamentoName || ""
  );
  if (res !== 0) return res;

  // 2. Área Cliente
  res = collator.compare(
    a.areasClientesName || "",
    b.areasClientesName || ""
  );
  if (res !== 0) return res;

  // 3. Artículo
  res = collator.compare(
    a.articuloDescripcion || "",
    b.articuloDescripcion || ""
  );
  if (res !== 0) return res;

  // 4. Color
  res = collator.compare(
    a.color || "",
    b.color || ""
  );
  if (res !== 0) return res;

  // 5. Talla (tu función)
  return ordenarPorTalla(a, b);
});

async function seleccionarPedidoColaborador(
  id,
  numero,
  idClientes,
  clientes,
  clientesCodigo,
  observaciones,
  empresa,
  idColaborador,
  idSociedad
) {
  try {
    setModoSurtido("colaborador");
setSelectedSucursalColaborador("");
    setSelectedPedido(id);
    setNumeroPedido(numero);
    setCliente(idClientes);
    setClientesName(clientes);
    setClientesCodigo(clientesCodigo);
    setObservaciones(observaciones);
    setNumeroFactura("");
    setEmpresa(empresa);
    setIdColaborador(idColaborador);
    setSelectedSociedad(idSociedad);

    setSelectedColaboradorCliente(null);
    setColaboradoresCliente([]);
    setColaboradoresTallas([]);
    setInputFields([]);
    setTotal(0);

    const [respCols, respTallas] = await Promise.all([
      axios.get(`${URL_COLABORADORES_CLIENTES}/cliente/${idClientes}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }),
      axios.get(`${URL_COLABORADORES_TALLAS}/cliente/${idClientes}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }),
    ]);

    setColaboradoresCliente(respCols.data || []);
    setColaboradoresTallas(respTallas.data || []);

    setModalSurtirColaborador(true);
  } catch (error) {
    console.log(error);
    Swal.fire(
      "Error",
      "No se pudo cargar la información del colaborador",
      "error"
    );
  }
}


const optionsColaboradorCliente = colaboradoresCliente.map((option) => {
  const junta = option.nombre;
  const firstLetter = option.nombre?.[0]?.toUpperCase() || "X";

  return {
    firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
    ...option,
    junta,
  };
});

const colaboradoresFiltrados = [...optionsColaboradorCliente]
  .filter((col) => {
    if (!selectedSucursalColaborador) return true;

    return (col.sucursales || []).some(
      (s) => String(s._id) === String(selectedSucursalColaborador)
    );
  })
  .sort((a, b) => -b.firstLetter.localeCompare(a.firstLetter));


async function cargarArticulosPorColaborador() {
  await cargarArticulosFiltradosPorColaborador(selectedColaboradorCliente);
  setModoSurtido("colaborador");
  setEsModoColaborador(false); // ya NO bloquear para que puedas cambiarlo
  setModalSurtirColaborador(false);
  setAbrirSurtir(true);
}

async function cargarArticulosFiltradosPorColaborador(colaboradorSeleccionado) {
  if (!selectedArea) {
    Swal.fire("Error", "Selecciona un almacén", "error");
    return;
  }

  if (!colaboradorSeleccionado?._id) {
    Swal.fire("Error", "Selecciona un colaborador", "error");
    return;
  }

  try {
    const res = await axios.get(
      `${URL_ARTICULOS_PEDIDO}/surtir3/${selectedPedido}/${selectedArea}`,
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    );

    const allArticulosPed = res.data || [];
    setArticulosPed(allArticulosPed);

    const registrosColaborador = (colaboradoresTallas || []).filter((ct) =>
      (ct.colaboradoresClientes || []).some(
        (cc) => String(cc._id || cc) === String(colaboradorSeleccionado._id)
      )
    );

    const combinacionesValidas = new Set();

    registrosColaborador.forEach((registro) => {
      const tallas = registro.tallas || [];
      const subDepartamentos = registro.subDepartamentos || [];

      tallas.forEach((t) => {
        if (subDepartamentos.length) {
          subDepartamentos.forEach((sd) => {
            combinacionesValidas.add(
              `${String(t._id || t)}_${String(sd._id || sd)}`
            );
          });
        } else {
          combinacionesValidas.add(`${String(t._id || t)}_`);
        }
      });
    });

    const articulosFiltrados = allArticulosPed.filter((a) => {
      const key = `${String(a.idTalla || "")}_${String(a.idSubDepartamento || "")}`;
      const keySinSub = `${String(a.idTalla || "")}_`;
      return combinacionesValidas.has(key) || combinacionesValidas.has(keySinSub);
    });

    const arrayInputFields = articulosFiltrados.map((a) => ({
      id: uuidv4(),
      articulos: a.articulos,
      articuloNombre: a.articuloNombre,
      articuloDescripcion: a.articuloDescripcion,
      cantidad: 0,
      cantInv: a.cantInv,
      idInv: a.idInv,
      idArtPed: a.idArtPed,
      precio: a.precio,
      total: 0,
      pendSurtir: a.pendiente_surtir,
      cantPed: a.cantPed,
      idTalla: a.idTalla,
      talla: a.talla,
      idColor: a.idColor,
      color: a.color,
      idSubDepartamento: a.idSubDepartamento || "",
      subDepartamentoName: a.subDepartamentoName || "",
      idDepartamento: a.idDepartamento || "",
      departamentoName: a.departamentoName || "",
      idAreasClientes: a.idAreasClientes || "",
      areasClientesName: a.areasClientesName || "",
    }));

    setInputFields(arrayInputFields);
    setTotal(0);
    setValue(colaboradorSeleccionado);
  } catch (err) {
    console.log(err);
    Swal.fire("Error", "No se pudieron cargar los artículos", "error");
  }
}
async function seleccionarPedidoSucursal(
  id,
  numero,
  idClientes,
  clientes,
  clientesCodigo,
  observaciones,
  empresa,
  idColaborador,
  idSociedad
) {
  try {
    setModoSurtido("sucursal");
    setSelectedPedido(id);
    setNumeroPedido(numero);
    setCliente(idClientes);
    setClientesName(clientes);
    setClientesCodigo(clientesCodigo);
    setObservaciones(observaciones);
    setNumeroFactura("");
    setEmpresa(empresa);
    setIdColaborador(idColaborador);
    setSelectedSociedad(idSociedad);

    setSelectedSucursal("");
    setSucursalesDisponibles([]);
    setColaboradoresCliente([]);
    setColaboradoresTallas([]);
    setInputFields([]);
    setTotal(0);

    const [respCols, respTallas] = await Promise.all([
      axios.get(`${URL_COLABORADORES_CLIENTES}/cliente/${idClientes}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }),
      axios.get(`${URL_COLABORADORES_TALLAS}/cliente/${idClientes}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }),
    ]);

    const cols = respCols.data || [];
    setColaboradoresCliente(cols);
    setColaboradoresTallas(respTallas.data || []);

    // Agrupar colaboradores por sucursal
    const sucursalMap = {};
    cols.forEach((col) => {
      const sucursal = col.sucursales?.[0]?.alias || col.sucursales?.[0]?.name || "Sin Sucursal";
      const idSuc = col.sucursales?.[0]?._id || "sin_sucursal";
      if (!sucursalMap[idSuc]) {
        sucursalMap[idSuc] = { _id: idSuc, nombre: sucursal, colaboradores: [] };
      }
      sucursalMap[idSuc].colaboradores.push(col);
    });

    setSucursalesDisponibles(Object.values(sucursalMap));
    setModalSurtirSucursal(true);
  } catch (error) {
    console.log(error);
    Swal.fire("Error", "No se pudo cargar la información de sucursales", "error");
  }
}

async function cargarArticulosPorSucursal() {
  if (!selectedArea) {
    Swal.fire("Error", "Selecciona un almacén", "error");
    return;
  }

  if (!selectedSucursal) {
    Swal.fire("Error", "Selecciona una sucursal", "error");
    return;
  }

  const sucursalObj = sucursalesDisponibles.find(
    (s) => String(s._id) === String(selectedSucursal)
  );

  const primerColaborador = sucursalObj?.colaboradores?.[0] || null;

  if (!primerColaborador) {
    Swal.fire("Error", "No hay colaboradores en esa sucursal", "error");
    return;
  }

  setSelectedSucursalColaborador(selectedSucursal);
  setSelectedColaboradorCliente(primerColaborador);

  await cargarArticulosFiltradosPorColaborador(primerColaborador);

  setModoSurtido("sucursal");
  setEsModoColaborador(false); // permitir cambiarlo, pero filtrado por sucursal
  setModalSurtirSucursal(false);
  setAbrirSurtir(true);
}

  return (
    <>
      <Header />
      <br />
      <br />
      {user.surtidos_create ? (
        <div className="card col-12">
          {abrirSurtirColaborador && (
  <div className="card container col-md-12">
    <h4>Surtir Pedido por Colaborador {numero_pedido}</h4>
    <h4>
      Cliente: {clientesCodigo} {clientesName}
    </h4>

    <Form>
      <Row>
        <Col md={3}>
          <Label>Almacén</Label>
          <Input
            type="select"
            value={selectedArea}
            onChange={(e) => setSelectedArea(e.target.value)}
          >
            <option value="">Selecciona</option>
            {areas.map((a) => (
              <option key={a._id} value={a._id}>
                {a.name}
              </option>
            ))}
          </Input>
        </Col>

        <Col md={2}>
          <Label>Impuestos %</Label>
          <Input
            type="number"
            value={impuestos}
            onChange={(e) => setImpuestos(Number(e.target.value) || 0)}
          />
        </Col>

        <Col md={5}>
          <Label>Colaborador</Label>
          <Autocomplete
            size="small"
            value={selectedColaboradorCliente}
            onChange={(event, newValue) => {
              setSelectedColaboradorCliente(newValue || null);
            }}
            options={[...optionsColaboradorCliente].sort(
              (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
            )}
            groupBy={(option) => option.firstLetter}
            getOptionLabel={(option) => option?.junta || ""}
            isOptionEqualToValue={(option, value) =>
              String(option?._id || "") === String(value?._id || "")
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label="Selecciona"
                variant="outlined"
              />
            )}
            renderOption={(option) => (
              <React.Fragment>{option.nombre}</React.Fragment>
            )}
          />
        </Col>

        <Col md={2} className="d-flex align-items-end">
          <Button color="success" onClick={cargarArticulosPorColaborador}>
            Cargar
          </Button>
        </Col>
      </Row>

      <br />

      <Button
        color="danger"
        onClick={() => setAbrirSurtirColaborador(false)}
      >
        Regresar
      </Button>
    </Form>
  </div>
)}

          {!abrirSurtir ? (
            <div>
              <Row>
                <Col md={8}>
                  <Button
                    size="sm"
                    href="/MenuVentas"
                    className="btn btn-danger"
                    id="botonListado"
                  >
                    Regresar
                  </Button>
                </Col>
                <Col sm={4}>
                  <ButtonGroup id="logoutBoton">
                    <Button
                      size="sm"
                      className="btn"
                      color="danger"
                      onClick={PDFTabla}
                    >
                      PDF <i class="far fa-file-pdf"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      onClick={toggleMail}
                      color="info"
                    >
                      eMail <i class="fas fa-at"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      color="primary"
                      onClick={excel}
                    >
                      Excel <i class="far fa-file-excel"></i>
                    </Button>
                  </ButtonGroup>
                </Col>
              </Row>
              <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
                <ModalHeader toggle={toggleMail}>
                  <h4>Enviar Listado Pendiente Surtir</h4>
                </ModalHeader>
                <ModalBody>
                  <Label className="mr-sm-2">Email</Label>
                  <Input
                    className="col-sm-12"
                    type="text"
                    value={mailTo}
                    required
                    onChange={(e) => {
                      setMailTo(e.target.value);
                    }}
                  />
                </ModalBody>
                <ModalFooter>
                  <Button size="sm" color="success" onClick={enviaMail}>
                    Enviar
                  </Button>
                </ModalFooter>
              </Modal>
              <h3 align="center">Entregas</h3>
              <div className="row">
                <div className="col-md-8">
                  <Pagination
                    total={totalItems}
                    itemsPerPage={ITEMS_PER_PAGE}
                    currentPage={currentPage}
                    onPageChange={(page) => setCurrentPage(page)}
                  />
                </div>
                <div className="col-md-4 d-flex flex-row-reverse">
                  <Search
                    onSearch={(value) => {
                      setSearch(value);
                      setCurrentPage(1);
                    }}
                  />
                </div>
              </div>

              <Row>
                <Col md={2}>
                  <Label className="mr-sm-2">Fecha Inicio</Label>
                  <Input
                    bsSize="sm"
                    type="date"
                    value={selectedFechaInicio}
                    required
                    onChange={(e) => {
                      setSelectedFechaInicio(e.target.value);
                    }}
                  />
                </Col>
                <Col md={2}>
                  <Label className="mr-sm-2">Fecha Fin</Label>
                  <Input
                    bsSize="sm"
                    type="date"
                    value={selectedFechaFin}
                    required
                    onChange={(e) => {
                      setSelectedFechaFin(e.target.value);
                    }}
                  />
                </Col>
                <Col md={2}>
                  <Label>Clientes</Label>
                  <Input
                    bsSize="sm"
                    type="select"
                    value={selectedCliente}
                    onChange={(e) => {
                      setSelectedCliente(e.target.value);
                      setCurrentPage(1);
                    }}
                  >
                    <option value="0">Selecciona</option>
                    {clientes
                      .sort((a, b) =>
                        a.nombre_comercial > b.nombre_comercial ? 1 : -1
                      )
                      .map((a) => {
                        return (
                          <option value={a._id}>{a.nombre_comercial}</option>
                        );
                      })}
                  </Input>
                </Col>

                <Col md={2}>
                  <Label>Vendedor</Label>
                  <Input
                    bsSize="sm"
                    type="select"
                    value={selectedColaborador}
                    onChange={(e) => {
                      setSelectedColaborador(e.target.value);
                      setCurrentPage(1);
                    }}
                  >
                    <option value="">Selecciona un Vendedor</option>
                    {colaboradores
                      .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                      .map((a) => {
                        return (
                          <option value={a._id}>
                            {a.nombre} {a.apellido}
                          </option>
                        );
                      })}
                  </Input>
                </Col>
              </Row>
              <br />
              <Table
                size="sm"
                striped
                borderless
                className="table-responsive-xl"
              >
                <TableHeader
                  headers={headers}
                  onSorting={(field, order) => setSorting({ field, order })}
                />
                <tbody>
                  {commentsData.map((a) => {
                      return (
                        <tr>
                          <td>{a.numero}</td>
                          <td>{a.fecha}</td>
                          <td>{a.empresaNombre}</td>
                          <td>{a.clientes}</td>
                          <td>{a.colaboradores}</td>
                          {/* <td>{a.marca}</td> */}
                          {/* <td>{a.articulo}</td> */}
                          <td>{a.pedidoCliente}</td>
                          <td>{a.fecha_cancelacion}</td>
                          <td className="text-center">{a.cantidadPedida}</td>
                          <td className="text-center">{a.cantidadSurtida}</td>
                          <td
                            className="text-center"
                            style={{
                              fontWeight: "bold",
                              color: a.pendienteSurtir > 0 ? "#c00000" : "#277c46",
                            }}
                          >
                            {a.pendienteSurtir}
                          </td>
                          <td>
                            {user.surtidos_create ? (
                              <div>
                                <Button
                                  size="sm"
                                  className="btn"
                                  color="danger"
                                  onClick={(e) =>
                                    PDFOC(
                                      a.fecha,
                                      a.colaboradores,
                                      a.clientes,
                                      a.pedidoCliente,
                                      a.numero,
                                      a._id,
                                      {
                                        empresa: a.empresaNombre,
                                        subCliente: a.subCliente,
                                        fechaEntrega: a.fecha_cancelacion,
                                      }
                                    )
                                  }
                                >
                                  <i class="far fa-file-pdf"></i>
                                </Button>

                                {/* <Button
                                  size="sm"
                                  className="btn"
                                  color="primary"
                                  onClick={(e) =>
                                    excelOC(
                                      a.idArea,
                                      a._id,
                                      a.clientes,
                                    )
                                  }
                                >
                                  <i class="far fa-file-excel"></i>
                                </Button> */}

                              </div>
                            ) : undefined}
                          </td>
                          <td>
                            <Button
                              color="info"
                              id="Editar"
                              size="sm"
                              onClick={(e) =>
                                seleccionarPedido(
                                  a._id,
                                  a.numero,
                                  // a.pedidoCliente,
                                  a.idClientes,
                                  a.clientes,
                                  a.clientesCodigo,
                                  a.observaciones,
                                  // a.idPedido,
                                  a.empresa,
                                  a.idColaborador,
                                  a.idSociedad,
                                  // a.descuento
                                )
                              }
                            >
                              <i class="fas fa-shipping-fast"></i>
                            </Button>

                            <Button
  color="primary"
  id="SurtirColaborador"
  size="sm"
  onClick={() =>
    seleccionarPedidoColaborador(
      a._id,
      a.numero,
      a.idClientes,
      a.clientes,
      a.clientesCodigo,
      a.observaciones,
      a.empresa,
      a.idColaborador,
      a.idSociedad
    )
  }
>
  <i className="fas fa-user-check"></i>
</Button>

                            <Button
  color="warning"
  id="SurtirSucursal"
  size="sm"
  onClick={() =>
    seleccionarPedidoSucursal(
      a._id,
      a.numero,
      a.idClientes,
      a.clientes,
      a.clientesCodigo,
      a.observaciones,
      a.empresa,
      a.idColaborador,
      a.idSociedad
    )
  }
>
  <i className="fas fa-store"></i>
</Button>
                          </td>
                          <td>
                            <StatusMultipleSurtido
                              idStatus={a._id}
                              status={a.status}
                              URL_STATUS={URL_PEDIDOS}
                              hijo={`${URL_ARTICULOS_PEDIDO}/baja`}
                            />
                          </td>
                        </tr>
                      );
                    }
                  )}
                </tbody>
              </Table>
              <div className="col-md-6">
                <Pagination
                  total={totalItems}
                  itemsPerPage={ITEMS_PER_PAGE}
                  currentPage={currentPage}
                  onPageChange={(page) => setCurrentPage(page)}
                />
              </div>
            </div>
          ) : (
            // Termina Abrir Surtir
            <div className="card container col-md-12">
              <h4>Surtir Pedido {numero_pedido}</h4>
              <h4>
                Cliente: {clientesCodigo} {clientesName}
              </h4>

              <Form onSubmit={saveSurtidos}>
                <Row>
                  <Col md={2}>
                    <Label>Fecha</Label>
                    <Input
                      type="date"
                      placeholder="Fecha"
                      value={fecha}
                      required
                      disabled
                    />
                  </Col>

                  <Col md={2}>
                    <Label>Impuestos %</Label>
                    <Input
                      type="number"
                      placeholder="Impuestos"
                      value={impuestos}
                      required
                      disabled
                    />
                  </Col>

                  <Col md={2}>
  <Label>Descuento</Label>
  <Input
    type="number"
    placeholder="descuento"
    value={descuento}
    required
    onChange={(e) => {
      setDescuento(Number(e.target.value) || 0);
    }}
  />
</Col>
<Col md={2}>
  <Label>Descuento 2</Label>
  <Input
    type="number"
    placeholder="descuento2"
    value={descuento2}
    required
    onChange={(e) => {
      setDescuento2(Number(e.target.value) || 0);
    }}
  />
</Col>
<Col md={3}>
  <Label>Nombre Colaborador</Label>
    <Autocomplete
  size="small"
  value={value || null}
  disabled={guardandoSurtido}
  onChange={async (event, nuevoColaborador) => {
    setValue(nuevoColaborador || null);

    if (!nuevoColaborador?._id) {
      setInputFields([]);
      setTotal(0);
      return;
    }

    // Si estás en modo sucursal, solo deja colaboradores de esa sucursal
    if (modoSurtido === "sucursal") {
      const pertenece = (nuevoColaborador.sucursales || []).some(
        (s) => String(s._id) === String(selectedSucursalColaborador)
      );

      if (!pertenece) {
        Swal.fire(
          "Error",
          "Solo puedes seleccionar colaboradores de la sucursal elegida",
          "error"
        );
        return;
      }
    }

    await cargarArticulosFiltradosPorColaborador(nuevoColaborador);
  }}
  options={
    (modoSurtido === "sucursal" ? colaboradoresFiltrados : options).sort(
      (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
    )
  }
  groupBy={(option) => option.firstLetter}
  getOptionLabel={(option) => option?.junta || ""}
  isOptionEqualToValue={(option, value) =>
    String(option?._id || "") === String(value?._id || "")
  }
  renderInput={(params) => (
    <TextField
      {...params}
      label="Selecciona"
      variant="outlined"
    />
  )}
  renderOption={(option) => (
    <React.Fragment>{option.nombre}</React.Fragment>
  )}
/>
</Col>

                  </Row>
                  <Row>
                    <Col md={2}>
                    <Label for="exampleEmail" className="mr-sm-2">
                      Entregado Con
                    </Label>
                    <Input
                      type="select"
                      placeholder="Entregado Con"
                      value={entregadoCon}
                      required
                      onChange={(e) => {
                        setEntregadoCon(e.target.value);
                      }}
                    >
                      <option value="">Selecciona</option>
                      <option value="Porta Trajes">Porta Trajes</option>
                      <option value="Bolsa">Bolsa</option>
                      <option value="Paquete">Paquete</option>
                      </Input>
                  </Col>
                  {/* (2026-10) obligatorio en cualquier tipo de entrega */}
                  <Col md={2}>
                    <Label className="mr-sm-2">Número de Factura *</Label>
                    <Input
                      type="text"
                      placeholder="Número de factura"
                      value={numeroFactura}
                      required
                      onChange={(e) => {
                        setNumeroFactura(e.target.value);
                      }}
                    />
                  </Col>
                  <Col md={6}>
                    <Label for="exampleEmail" className="mr-sm-2">
                      Observaciones
                    </Label>
                    <Input
                      type="text"
                      placeholder="Observaciones"
                      value={observaciones}
                      required
                      onChange={(e) => {
                        setObservaciones(e.target.value);
                      }}
                    />
                  </Col>
                </Row>

                <br />
                {/* Tabla Articulos */}
                {/* <Row>
                  <Col md={8}></Col>
                  <Col md={1}>
                  <Button
                  size="sm"
                  color="success"
                  onClick={handleCopyAllCantidad}
                >
                 Todo el Inventario
                </Button>
                  </Col>
                </Row> */}

                <Row>
                  {/* <Col md={1}>
                    <Label className="mr-sm-2">Codigo QR</Label>
                  </Col> */}
                  <Col md={1}>
                    <Label className="mr-sm-2">Genero</Label>
                  </Col>
                  <Col md={2}>
                    <Label className="mr-sm-2">Area</Label>
                  </Col>
                  <Col md={2}>
                    <Label className="mr-sm-2">Modelo</Label>
                  </Col>
                  <Col md={1}>
                    <Label className="mr-sm-2">Color</Label>
                  </Col>
                  <Col md={2}>
                    <Label className="mr-sm-2">Talla</Label>
                  </Col>
                  {/* <Col md={1}>
                    <Label className="mr-sm-2">Precio</Label>
                  </Col> */}
                  <Col md={1}>
                    <Label className="mr-sm-2">Cant Pedido</Label>
                  </Col>
                  <Col md={1}>
                    <Label className="mr-sm-2">Pend Surtir</Label>
                  </Col>

                  <Col md={1}>
                    <Label className="mr-sm-2">Inventario</Label>
                  </Col>

                  <Col md={1}>
                    <Label className="mr-sm-2">Cantidad</Label>
                  </Col>
                </Row>


                {inputFieldsOrdenados.map((inputField) => (
                  <div key={inputField.id}>
                    <Row>
                      {/* <Col md={1}>
                        <Input
                          bsSize="sm"
                          name="articulos"
                          type="string"
                          value={inputField.articulos}
                          disabled
                        ></Input>
                      </Col> */}
                      <Col md={1}>
                        <Input
                          bsSize="sm"
                          name="articulos"
                          type="text"
                          value={inputField.departamentoName}
                          required
                          disabled
                        />
                      </Col>
                      <Col md={2}>
                        <Input
                          bsSize="sm"
                          name="articulos"
                          type="text"
                          value={inputField.areasClientesName}
                          required
                          disabled
                        />
                      </Col>
                      <Col md={2}>
                        <Input
                          bsSize="sm"
                          name="articulos"
                          type="select"
                          value={inputField.articulos}
                          required
                          disabled
                        >
                          <option value="">Selecciona un Articulo</option>
                          {articulosPed
                            .sort((a, b) =>
                              a.articuloNombre > b.articuloNombre ? 1 : -1
                            )
                            .map((a) => {
                              return (
                                <option value={a.articulos}>
                                  {a.articuloNombre}
                                </option>
                              );
                            })}
                        </Input>
                      </Col>
                      <Col md={1}>
                        <Input
                          bsSize="sm"
                          name="color"
                          type="text"
                          min="0"
                          step="any"
                          placeholder="color"
                          value={inputField.color}
                          disabled
                        />
                      </Col>
                      <Col md={2}>
                        <Input
                          bsSize="sm"
                          name="talla"
                          type="text"
                          min="0"
                          step="any"
                          placeholder="talla"
                          value={inputField.talla}
                          disabled
                        />
                      </Col>
                      {/* <Col md={1}>
                        <Input
                          bsSize="sm"
                          name="precio"
                          type="number"
                          min="0"
                          step="any"
                          placeholder="Precio"
                          value={inputField.precio}
                          disabled
                        />
                      </Col> */}
                      <Col md={1}>
                        <Input
                          bsSize="sm"
                          name="cantPed"
                          type="number"
                          min="0"
                          step="any"
                          placeholder="Cant Ped"
                          value={inputField.cantPed}
                          disabled
                        />
                      </Col>
                      <Col md={1}>
                        <Input
                          bsSize="sm"
                          name="pendSurtir"
                          type="number"
                          min="0"
                          step="any"
                          placeholder="Cantidad"
                          value={inputField.pendSurtir}
                          required
                          disabled
                        />
                      </Col>

                      <Col md={1}>
                        <Input
                          bsSize="sm"
                          name="cantInv"
                          type="number"
                          min="0"
                          step="any"
                          placeholder="Cantidad"
                          value={inputField.cantInv}
                          required
                          disabled
                        />
                      </Col>

                     

                      <Col md={1}>
                        <Input
                          bsSize="sm"
                          name="cantidad"
                          type="number"
                          min="0"
                          step="any"
                          placeholder="Cantidad"
                          value={inputField.cantidad}
                          required
                          onChange={(event) =>
                            handleChangeInputCantidad(inputField.id, event)
                          }
                        />
                      </Col>

      {/* <Col md={1}>
        <Button
          size="sm"
          color="primary"
          onClick={() => handleCopyCantidad(inputField.id)}
        >
          Copiar
        </Button>
      </Col> */}

                    </Row>
                  </div>
                ))}
                <Row>
                  <Col md={10}>
                    <h4 id="logoutBoton">
                      TOTAL {total} Pzas.
                    </h4>
                  </Col>
                </Row>
                {/* Termina Tabla Articulos */}

                <br />
                {validaBoton ? (
                  <Button type="submit" className="btn btn-success">
                    Guardar
                  </Button>
                ) : (
                  <Button type="submit" className="btn btn-success" disabled>
                    Guardar
                  </Button>
                )}
                <Button
                  onClick={(e) => setAbrirSurtir(false)}
                  className="btn btn-danger"
                  id="botonListado"
                >
                  Regresar
                </Button>
              </Form>
            </div>
          )}
        </div>
      ) : undefined}
      <br />

     <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
             <h4> Este proceso puede tardar varios segundos.
              <br />
              Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                  <Spinner
                    style={{
                      width: "50px",
                      height: "50px",
                      color: "#232B41",
                    }}
                  />
                  <Spinner
                    style={{
                      width: "50px",
                      height: "50px",
                      color: "#232B41",
                    }}
                  />
                  <Spinner
                    style={{
                      width: "50px",
                      height: "50px",
                      color: "#232B41",
                    }}
                  />
              </div>
            </ModalBody>
          </Modal>
          <Modal size="sm" isOpen={modalAlmacen} toggle={toggleAlmacen}>
                <ModalHeader toggle={toggleAlmacen}>
                  <h4>Selecciona un almacen</h4>
                </ModalHeader>
                <ModalBody>
                <Label className="mr-sm-2">Almacen</Label>
                  <Input
                    type="select"
                    value={selectedArea}
                    onChange={(e) => {
                      setSelectedArea(e.target.value);
                    }}
                  >
                    <option value="">Selecciona un Almacen</option>
                    {areas
                      .sort((a, b) => (a.name > b.name ? 1 : -1))
                      .map((a) => {
                        if(a.name != "General"){
                        return (
                          <option value={a._id}>
                            {a.name}
                          </option>
                        );
                      }
                      })
                      }
                  </Input>
                  <Label className="mr-sm-2">Impuestos</Label>
                  <Input
                    type="select"
                    value={impuestos}
                    onChange={(e) => {
                      setImpuestos(e.target.value);
                    }}
                  >
                    <option value="">Selecciona</option>
                    <option value={0}>No</option>
                    <option value={16}>Si</option>
                    
                  </Input>
                </ModalBody>
                <ModalFooter>
                  <Button size="sm" color="success" onClick={(e) => surtirPedido()}>
                    Continuar
                  </Button>
                </ModalFooter>
              </Modal>
<Modal isOpen={modalSurtirColaborador} toggle={toggleModalSurtirColaborador}>
  <ModalHeader toggle={toggleModalSurtirColaborador}>
    Surtir por colaborador
  </ModalHeader>

  <ModalBody>
    <Row>
      <Col md={12}>
        <Label>Almacen</Label>
        <Input
          type="select"
          value={selectedArea}
          onChange={(e) => setSelectedArea(e.target.value)}
        >
          <option value="">Selecciona</option>
         {areas
                      .sort((a, b) => (a.name > b.name ? 1 : -1))
                      .map((a) => {
                        if(a.name != "General"){
                        return (
                          <option value={a._id}>
                            {a.name}
                          </option>
                        );
                      }
                      })
                      }
        </Input>
      </Col>
    </Row>

    <Row>
      <Col md={12}>
        <Label>Impuestos %</Label>
        <Input
                    type="select"
                    value={impuestos}
                    onChange={(e) => {
                      setImpuestos(e.target.value);
                    }}
                  >
                    <option value="">Selecciona</option>
                    <option value={0}>No</option>
                    <option value={16}>Si</option>
                    
                  </Input>
      </Col>
    </Row>

    <Row>
    <Col md={12}>
      <Label>Sucursal</Label>
      <Input
        type="select"
        value={selectedSucursalColaborador}
        onChange={(e) => {
          setSelectedSucursalColaborador(e.target.value);
          setSelectedColaboradorCliente(null);
        }}
      >
        <option value="">Todas</option>
        {[...new Map(
          optionsColaboradorCliente
            .flatMap((c) => c.sucursales || [])
            .map((s) => [s._id, s])
        ).values()]
          .sort((a, b) => (a.alias > b.alias ? 1 : -1))
          .map((s) => (
            <option key={s._id} value={s._id}>
              {s.alias}
            </option>
          ))}
      </Input>
    </Col>
  </Row>

   <Row>
  <Col md={12}>
    <Label>Colaborador</Label>
    <Autocomplete
      size="small"
      value={selectedColaboradorCliente}
      onChange={(event, newValue) => {
        setSelectedColaboradorCliente(newValue || null);
      }}
      options={[...colaboradoresFiltrados].sort(
        (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
      )}
      groupBy={(option) => option.firstLetter}
      getOptionLabel={(option) => option?.junta || ""}
      isOptionEqualToValue={(option, value) =>
        String(option?._id || "") === String(value?._id || "")
      }
      renderInput={(params) => (
        <TextField
          {...params}
          label="Selecciona"
          variant="outlined"
        />
      )}
      renderOption={(option) => (
        <React.Fragment>{option.nombre}</React.Fragment>
      )}
    />
  </Col>
</Row>
  </ModalBody>

  <ModalFooter>
    <Button color="success" onClick={cargarArticulosPorColaborador}>
      Continuar
    </Button>
    <Button color="danger" onClick={toggleModalSurtirColaborador}>
      Cancelar
    </Button>
  </ModalFooter>
</Modal>
<Modal isOpen={modalSurtirSucursal} toggle={toggleModalSurtirSucursal}>
  <ModalHeader toggle={toggleModalSurtirSucursal}>
    Surtir por Sucursal
  </ModalHeader>

  <ModalBody>
    <Row>
      <Col md={12}>
        <Label>Almacen</Label>
        <Input
          type="select"
          value={selectedArea}
          onChange={(e) => setSelectedArea(e.target.value)}
        >
          <option value="">Selecciona</option>
          {areas
            .sort((a, b) => (a.name > b.name ? 1 : -1))
            .map((a) => {
              if (a.name !== "General") {
                return (
                  <option key={a._id} value={a._id}>
                    {a.name}
                  </option>
                );
              }
            })}
        </Input>
      </Col>
    </Row>

    <Row>
      <Col md={12}>
        <Label>Impuestos %</Label>
        <Input
          type="select"
          value={impuestos}
          onChange={(e) => setImpuestos(e.target.value)}
        >
          <option value="">Selecciona</option>
          <option value={0}>No</option>
          <option value={16}>Si</option>
        </Input>
      </Col>
    </Row>

    <Row>
      <Col md={12}>
        <Label>Sucursal</Label>
        <Input
          type="select"
          value={selectedSucursal}
          onChange={(e) => setSelectedSucursal(e.target.value)}
        >
          <option value="">Selecciona una Sucursal</option>
          {sucursalesDisponibles
            .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
            .map((s) => (
              <option key={s._id} value={s._id}>
                {s.nombre} ({s.colaboradores.length} colaborador{s.colaboradores.length !== 1 ? "es" : ""})
              </option>
            ))}
        </Input>
      </Col>
    </Row>

    {selectedSucursal && (
      <Row className="mt-2">
        <Col md={12}>
          <small className="text-muted">
            <strong>Colaboradores incluidos: </strong>
            {sucursalesDisponibles
              .find((s) => s._id === selectedSucursal)
              ?.colaboradores.map((c) => c.nombre)
              .join(", ")}
          </small>
        </Col>
      </Row>
    )}
  </ModalBody>

  <ModalFooter>
    <Button color="success" onClick={cargarArticulosPorSucursal}>
      Continuar
    </Button>
    <Button color="danger" onClick={toggleModalSurtirSucursal}>
      Cancelar
    </Button>
  </ModalFooter>
</Modal>

      {loader}
    </>
  );
}

export default ListadoPendienteSurtir;
